import useSWR from "swr"
import { InboundOrderApi } from "../../../apis"

export function useInboundOrderQuery(id: string | null | undefined) {
  return useSWR(
    id ? ["inbound-order", id] : null,
    async () => InboundOrderApi.get(id as string),
    { revalidateOnFocus: false },
  )
}
